// @flow
import React, { type Node } from 'react';

import { ExternalLink, GatsbyLink } from './components';

type Props = {
  to: string,
  children: Node,
  external?: boolean,
};

export const ButtonLink = ({
  to,
  external,
  children,
  ...others
}: Props) => (
  external ? (
    <ExternalLink
      href={to}
      {...others}
    >
      {children}
    </ExternalLink>
  ) : (
    <GatsbyLink
      to={to}
      {...others}
    >
      {children}
    </GatsbyLink>
  )
);

ButtonLink.defaultProps = {
  external: false,
};
